import { render, staticRenderFns } from "./my-checkbox-group.vue?vue&type=template&id=275f3614&scoped=true&"
import script from "./my-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./my-checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f3614",
  null
  
)

export default component.exports